import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/all'
import { waitForFonts } from '../utils/fonts'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(SplitText)

export const initGlobalAnimations = async () => {
  // Wait for fonts to load before initializing SplitText animations
  await waitForFonts()

  let mm = gsap.matchMedia()

  gsap.config({
    nullTargetWarn: false,
  })

  window.addEventListener('resize', () => {
    ScrollTrigger.refresh()
  })

  mm.add('(prefers-reduced-motion: no-preference)', () => {
    const fadeInEls: HTMLElement[] = gsap.utils.toArray('.kd-fade-in')
    fadeInEls.forEach((el) => {
      // animate words from bottom
      gsap.from(el, {
        opacity: 0,
        yPercent: 20,
        duration: 1,
        ease: 'power4.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 60%',
          //markers: true,
        },
      })
    })

    const fadeWords: HTMLElement[] = gsap.utils.toArray('.kd-fade-words-in')
    fadeWords.forEach((el) => {
      const split = new SplitText(el, { type: 'words', mask: 'words' })
      const staggerAmount = split.words.length < 10 ? 0.05 : 0.01
      const underlineEls: HTMLElement[] = gsap.utils.toArray(
        '.underline-marked-white, .underline-marked-black',
        el,
      )

      // animate words from bottom
      gsap.from(split.words, {
        opacity: 0,
        yPercent: 120,
        rotate: 5,
        duration: 1,
        ease: 'power4.out',
        stagger: {
          each: staggerAmount,
          from: 'start',
        },
        scrollTrigger: {
          trigger: el,
          start: 'top 80%',
          //markers: true,
        },
        onComplete: () => {
          if (underlineEls.length) {
            gsap.to(underlineEls, {
              '--underline-clip': '0%',
              duration: 0.6,
              ease: 'power3.out',
            })
          }
        },
      })
    })

    const textEls: HTMLElement[] = gsap.utils.toArray('.kd-text-in')
    textEls.forEach((el) => {
      const split = new SplitText(el, {
        type: 'chars, lines',
        mask: 'lines',
        // autoSplit: true, // breaks animation somehow
      })

      // animate letters from bottom
      gsap.from(split.chars, {
        yPercent: 110,
        rotate: 5,
        duration: 0.6,
        ease: 'power4.out',
        stagger: {
          each: 0.01,
          from: 'start',
        },
        scrollTrigger: {
          trigger: el,
          start: 'top 80%',
          //markers: true,
        },
      })
    })

    const fadeEls: HTMLElement[] = gsap.utils.toArray('.kd-fade-els-in')
    fadeEls.forEach((el) => {
      const children = el.children
      // animate words from bottom
      gsap.from(children, {
        opacity: 0,
        yPercent: 50,
        duration: 1,
        ease: 'power4.out',
        stagger: {
          each: 0.1,
          from: 'start',
        },
        scrollTrigger: {
          trigger: el,
          start: 'top 80%',
          //markers: true,
        },
      })
    })

    const fadeImageInEls: HTMLElement[] = gsap.utils.toArray('.kd-image-in')
    fadeImageInEls.forEach((el) => {
      // animate words from bottom
      gsap.from(el, {
        opacity: 0,
        duration: 1,
        ease: 'power4.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 60%',
          //markers: true,
        },
      })
    })
  })
}
